import Cookies from "js-cookie";
import React, { useEffect, useRef } from "react";
import { request } from "../../../config/helpers/axios-instance";
import "../../../styles/Signup.scss";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { COOKIE_EXPIRY_FOR_TOKEN } from "../../../utils/constants";
import { COOKIE_EXPIRY_FOR_REFRESH_TOKEN, COOKIE_EXPIRY_FOR_ROLES, COOKIE_EXPIRY_FOR_TOKEN_EXPIRES_AT, COOKIE_EXPIRY_FOR_USER } from "../../../utils/constants";
import { defaultConsoleId, landingPathFor } from "../../../v2/constants/consoles";
import { loadPreferredConsoleId } from "../../../v2/constants/consolePreference";
const Contexts = require("../../../contexts");

const cookies = Cookies.withConverter({
    write: function (value, name) {
        if (name === 'token' || name === 'refresh_token') {
            return value
        } else {
            return value
        }
    }
})

function OTPForm() {
    const { authState, authDispatch } = React.useContext(Contexts.Auth);
    const ref = useRef()
    const onSubmit = async (e) => {
        e.preventDefault()
        const response = await request({
            url: `user/verifyOtp`,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: {
                username: authState.contact_no,
                otp: authState.otp,
            },
            checkRefresh: false
        });

        if (response.status === 200 && response.data.error === "") {
            const login = await request({
                url: `user/login`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                auth: {
                    username: authState.contact_no,
                    password: authState.otp,
                },
                data: {
                    tenantId: Cookies.get("tenantId")
                },
                checkRefresh: false
            });
            if (login.status === 200) {
                const decoded = jwtDecode(login?.data?.data?.token?.split(":")[0])

                const expiresAt = decoded?.expiresAt
                login.data.data.user.mappings = []

                const roles = login.data.data.user.roles

                cookies.set("token", login.data.data.token, { expires: COOKIE_EXPIRY_FOR_TOKEN });
                cookies.set("user", JSON.stringify(login.data.data.user), { expires: COOKIE_EXPIRY_FOR_USER });
                cookies.set("roles", JSON.stringify(roles), { expires: COOKIE_EXPIRY_FOR_ROLES });
                cookies.set("refresh_token", login.data.data.refreshToken, { expires: COOKIE_EXPIRY_FOR_REFRESH_TOKEN });
                cookies.set("token_expires_at", expiresAt, { expires: COOKIE_EXPIRY_FOR_TOKEN_EXPIRES_AT });
                // Role decides which console you land on; a stored preference overrides
                // it. This replaced a four-branch if/else over legacy paths that KAM,
                // DOCTOR and PARTNER fell straight through -- they authenticated, got
                // their cookies, and were left sitting on /login. landingPathFor()
                // always resolves to something loadable (worst case /welcome), so no
                // role falls through now.
                //
                // Still a full-page load rather than navigate(): the legacy route table
                // is built once at import time (src/navigation/routes.jsx calls useRoles
                // inside a module-scope .map()), so a client-side navigation here would
                // run against a router constructed before these cookies existed.
                const consoleId = loadPreferredConsoleId(roles) ?? defaultConsoleId(roles)
                window.location.href = landingPathFor(consoleId, roles)
            }
            else {
                toast.error('Something went wrong!')
            }
        }
        else {
            toast.error('Otp is not correct!')
        }
    };

    useEffect(() => {
        ref.current.focus()
    }, [])
    return (
        <>
            <div className="flex flex-col  w-96 items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
                <h1 className="font-sans text-6xl font-bold mb-8">
                    PillEngine
                </h1>
                <div className="w-full bg-white-50 rounded-2xl shadow-soft-xl  font-sans">
                    <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                        <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl text-left ">
                            OTP has been sent to your mobile
                        </h1>
                        <form onSubmit={(e) => onSubmit(e)}>
                            <div>
                                <label className="block mb-2 text-sm font-medium text-gray-900 ">
                                    Your OTP
                                </label>
                                <input
                                    name="otp"
                                    id="otp"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-2xl focus:ring-primary-600 focus:border-primary-600 block  p-2.5 w-full"
                                    placeholder="Enter Your OTP Here"
                                    maxLength={6}
                                    required={true}
                                    value={authState.otp}
                                    ref={ref}
                                    onChange={(e) => {
                                        if (!isNaN(e.target.value)) {
                                            authDispatch({ ...authState, otp: e.target.value })
                                        }
                                    }

                                    }
                                />
                            </div>

                            <button
                                type="submit"
                                id="signup"
                                className="w-full font-sans text-white-50bg-green-600 hover:bg-green-700 hover:text-white focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-2xl text-sm px-5 py-2.5 text-left mt-2">
                                Sign in
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export { OTPForm };
